import { useMutation } from "@apollo/client";
import { SUBMIT_INTERVIEW_ANSWER } from "graphql/mutations";

export default function useSubmitInterviewAnswer() {
  const [submitInterviewAnswer, { loading, error }] = useMutation(SUBMIT_INTERVIEW_ANSWER);

  const handleSubmitInterviewAnswer = async (profileId, interviewId, questionId, signedId) => {
    const res = await submitInterviewAnswer({
      variables: {
        input: {
          profileId,
          interviewId,
          questionId,
          videoSignedBlobId: signedId,
        },
      },
    });

    return res?.data?.submitInterviewAnswer;
  };

  return {
    handleSubmitInterviewAnswer,
    loading,
    error,
  };
}
